import {Directive, EventEmitter, Output, Self} from "@angular/core";
import {MatSelect} from "@angular/material/select";

@Directive({
  selector: '[no-keyboard-action]',
  standalone: false
})
export class NoKeyboardActionDirective {
  @Output('keyDown') keyDown: EventEmitter<any> = new EventEmitter<any>();

  constructor(@Self() private select: MatSelect) {
    this.select._handleKeydown = () => {
      const activeOption = this.select.panelOpen ? this.select.options.find(option => option.active) || null : null;
      this.keyDown.emit(activeOption ? activeOption.value : null);
    };
  }
}
